import React from 'react';
import { withSnackbar } from 'notistack';
import CaseStatusFormDetailPres from '../presentational/CaseStatusFormDetailPres';

class CaseStatusFormDetailContainer extends React.Component {
  render() {
    const { isActive, bpfStatusInfo, caseClosed, isCorpClient, isCorpClientLineManager, isCaseLoading } = this.props;

    return (
      isActive && (
        <CaseStatusFormDetailPres
          bpfStatusInfo={bpfStatusInfo}
          isActive={isActive}
          isActionBarHidden={true}
          isCorpClient={isCorpClient || caseClosed}
          caseClosed={caseClosed}
          isLoading={isCaseLoading}
          isCorpClientLineManager={isCorpClientLineManager}></CaseStatusFormDetailPres>
      )
    );
  }
}

export default withSnackbar(CaseStatusFormDetailContainer);
